import React, { useState, useEffect } from 'react'
import {
  Button,
  SimpleModal,
  ModalTitle,
  ModalContent,
  ModalFooter,
  TextField
} from '@deal/components'
import { useCreateShareLinkMutation } from '#src/generated/graphql'

interface Props {
  onRequestClose: () => void
  linkShareUrl: string
}

const ShortLinkModal: React.SFC<Props> = ({ onRequestClose, linkShareUrl }) => {
  const [shortUrl, setShortUrl] = useState('')

  const [createShareLink, { loading }] = useCreateShareLinkMutation({
    variables: {
      input: {
        url: linkShareUrl,
        preferredDomain: 'curatedrefer.com'
      }
    },
    onCompleted: ({ shortenUrl }) => shortenUrl && setShortUrl(shortenUrl.url)
  })

  useEffect(() => {
    createShareLink()
  }, [])

  return (
    <SimpleModal isOpen={true} onRequestClose={onRequestClose}>
      <ModalTitle>Send to a friend</ModalTitle>
      <ModalContent>
        <p>Share with a friend via the link below!</p>
        <TextField
          loading={loading}
          value={shortUrl}
          display="standard"
          autoFocus={false}
          label="referral link"
          labelHidden={true}
        />
      </ModalContent>
      <ModalFooter>
        <Button onClick={onRequestClose} variant="contrast">
          Okay!
        </Button>
      </ModalFooter>
    </SimpleModal>
  )
}

export default ShortLinkModal
